import { Box } from "@powerledger/ui-component-lib";

import { AccountType, RegistryCode } from "@/app/types/generated/graphql";
import { ReactComponent as IrecLogo } from "@/assets/images/irecLogo.svg";
import { ErcotLogo } from "@/assets/logos/ercot-logo";
import { MretsLogo } from "@/assets/logos/mrets-logo";

export const registryLogoMap: Record<string, any> = {
  ERCOT: (
    <Box
      sx={{
        width: "100%",
        height: "75px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        svg: {
          width: "100%",
          height: "40px",
        },
      }}
    >
      <ErcotLogo />
    </Box>
  ),
  MRETS: (
    <Box
      sx={{
        width: "100%",
        height: "75px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        svg: {
          width: "100%",
          height: "35px",
        },
      }}
    >
      <MretsLogo />
    </Box>
  ),
  IREC: <IrecLogo />,
};

export const ERCOT_HELPER_TEXT = [
  "If proposing to import ERCOT Product for sale on the Marketplace, the Participant's Products will need to be transferred to the Product Holder from this account.",
  "If the Registry Account details are not provided, the Participant will not be able to import ERCOT Products, but may still purchase Products on the Marketplace for the purposes of retirement only.",
  "If the Registry account details are provided, the Product Holder will automatically transfer any ERCOT Products purchased on the Marketplace to that Registry Account following settlement.",
  "ERCOT Products purchased on the Marketplace will NOT be able to be resold on the Marketplace, but will be exported to the Participant's Registry Account (if the Registry Account is provided) or retired on behalf of the Participant (if the Registry Account is not provided).",
];

export const guidanceText = ({
  registryCode,
  accountType,
}: {
  registryCode: RegistryCode;
  accountType: AccountType;
}) => {
  if (!registryCode) return "";

  if (registryCode === RegistryCode.Mrets) {
    if (accountType === AccountType.Registry) {
      return "Need to find the ID? You can access it by logging into the Participant's M-RETS account, accessing the profile on the top-right, and then clicking on 'Organization Info'.\nOnce you have sent a link request from this page, please accept the invite from the M-RETS dashboard.";
    } else if (accountType === AccountType.NonRegistry) {
      return "This account type allows a Participant to buy MRETS Products on the Marketplace without having their own Registry Account. With this type of account, the Participant will be able to buy MRETS Products for the purposes of retirement only. The purchased Products will be held by the Product Holder subject to the Product Holding Terms. These Products will NOT be able to be resold on the Marketplace.";
    }
  }
  if (registryCode === RegistryCode.Ercot) {
    return "With this type of account, the Participant will be able to import, trade and retire ERCOT Products on the Marketplace. Imported and purchased ERCOT Products will be held by the Product Holder subject to the Product Holding Terms.";
  }
  return "";
};

export const getInputFieldLabel = (registryCode: RegistryCode) => {
  if (registryCode === RegistryCode.Ercot) {
    return "If the Applicant has its own ERCOT Registry Account, you can provide it below:";
  }
  if (registryCode === RegistryCode.Mrets) {
    return "Please provide Participant’s MRETS ID:";
  }
  return "";
};
